import React, { useMemo } from "react";
import {
    MetricsDashboardGraphTypeDisplayType,
} from "../../../__generated__/api";
import { useTheme } from "../../../contexts/Theme";
import Styles from "../Reports.module.scss";
import {
    filter, formatValueWithDisplay,
    getMetricValue,
    GraphProps,
    GraphSettingsProperties,
} from "./base";
import Filters from "./Filters";
import MetricProperties from "./MetricProperties";
import Title from "./Title";

export function ChartProperties(props: GraphSettingsProperties) {
    return (

        <div>
            <MetricProperties {...props} />

            <Filters isAdmin={props.isAdmin} graph={props.graph} onChange={props.onChange} />

        </div>
    );
}

export default function CountChart(props: GraphProps) {
    const theme = useTheme();
    const textValue = useMemo(() => {
        const metric = props.graph.metrics?.firstElement;
        const fieldIndex = props.data.columns.findIndex(row => row.id === metric?.fieldId);

        const dataRows = filter(props.data.rows, props.graph.filters, props.columnIndexMap);
        const values = dataRows.map(row => row.values[fieldIndex]).filter(row => row != null && row !== "") as string[];
        const value = getMetricValue(values, metric?.aggregation);

        const display = metric?.display ?? MetricsDashboardGraphTypeDisplayType.Number;

        return formatValueWithDisplay(value, display);
    }, [props.data, props.graph]);

    return (
        <div className={theme.isV3 ? Styles["count-container"] : ""}>
            <Title isAdmin={props.isAdmin} graph={props.graph} createMenu={props.createMenu} size="small" />

            <h4 className={theme.isV3 ? Styles["count-value"] : "text-blue-dark text-center"}>
                {textValue}
            </h4>

        </div>
    );
}
